export default __webpack_public_path__ + "static/media/brace-symbol-bg.9510fa94.svg";